import { Time } from '@instinet-analytics/core-lib';
import { VolumeCurveData } from 'widgets/volumeCurve/data/volumeCurveData.ts';
import React from 'react';
import { useVolumeCurveComponentSlice } from 'widgets/volumeCurve/store/component/componentSlice.ts';
import { TimeLabel } from 'utils/components/TimeLabel/TimeLabel.tsx';

export function VolumeCurveTimeLabel({ data }: { data: VolumeCurveData }) {
    const { component, dispatchComponentChanged } =
        useVolumeCurveComponentSlice();

    const onChanged = (
        startTime: Time | undefined,
        endTime: Time | undefined
    ) => {
        dispatchComponentChanged({ startTime, endTime });
    };

    return (
        <TimeLabel component={component} data={data} onChanged={onChanged} />
    );
}
